var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg1214Bell = function Svg1214Bell(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF8B4E",
    d: "M1.38 11.563h11.24c.312 0 .489-.48.305-.755a4.9 4.9 0 0 1-.84-2.705l.02-1.547C12.104 3.488 9.818 1 7 1 4.222 1 1.97 3.451 1.97 6.475L1.95 8.103c0 1.123-.428 2.056-.872 2.692-.191.274-.015.768.301.768"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FF8B4E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 15h4m-7.62-3.437c-.316 0-.492-.494-.301-.768.444-.636.872-1.569.872-2.692l.018-1.628C1.97 3.451 4.222 1 7 1c2.82 0 5.105 2.488 5.105 5.556l-.018 1.547c0 1.131.413 2.069.84 2.705.183.275.006.755-.306.755z"
  })));
};
export default Svg1214Bell;